import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalaryStructure, SalaryStructureCreate, SalaryStructureFilter } from '../data/salaryStructure';

export function createSalaryStructureService(client: AxiosInstance) {
  return createCrudService<SalaryStructure, SalaryStructureCreate, SalaryStructureFilter>(client, "/hrm/SalaryStructure", "salaryStructureId");
}

export type SalaryStructureService = CrudService<
  SalaryStructure,
  SalaryStructureCreate,
  SalaryStructureFilter
>;
